<template>
  <div id='box'>
      <footer class="footer">
    <div class="footer-inner container">
      <div class="footer-top">
          <div class="footer-top-title">Engineering Excellence: Delivering World-Class Steel Structure Solutions Globally</div>

        <img src="/imgs/home/images/footer-logo_03.png" alt="" />

      </div>
      <div class="footer-bottom">
          <dl class="footer-list">
            <div class="footer-col">
              <router-link to="/goin"><dt>About Us</dt></router-link>
              <dd><router-link to="/goin">Company Profile </router-link></dd>
              <dd><router-link to="/goin">Milestones</router-link></dd>
              <dd><router-link to="/goin">Corporate Culture</router-link></dd>
              <dd><router-link to="/goin">Certifications & Awards</router-link></dd>
              <dd><router-link to="/goin">Careers</router-link></dd>
            </div>
            <div class="footer-col">
              <router-link to="/product"><dt>Products</dt></router-link>
              <dd><router-link to="/product">Swine Facilities</router-link></dd>
              <dd><router-link to="/product">Poultry Houses</router-link></dd>
              <dd><router-link to="/product">Greenhouse Systems</router-link></dd>
              <dd><router-link to="/product">Agricultural Barns</router-link></dd>
              <dd><router-link to="/product">Grain Storage Solutions</router-link></dd>
            </div>
            <div class="footer-col">
              <router-link to="/tech"><dt>Technology & R&D</dt></router-link>
              <dd><router-link to="/tech">Project Portfolio</router-link></dd>
              <dd><router-link to="/tech">Building Standards </router-link></dd>
              <dd><router-link to="/tech">Innovation</router-link></dd>
              <dd><router-link to="/tech">Materials Research</router-link></dd>
              <dd><router-link to="/tech">International Project Experience</router-link></dd>
            </div>
            <div class="footer-col">
              <router-link to="/application"><dt>Applications</dt></router-link>
              <dd><router-link to="/application">Livestock</router-link></dd>
              <dd><router-link to="/application">Crop Production</router-link></dd>
              <dd><router-link to="/application">Aquaculture</router-link></dd>
              <dd><router-link to="/application">Agri-processing</router-link></dd>
              <dd><router-link to="/application"> Storage & Logistics</router-link></dd>
            </div>
            <!-- <div class="footer-col">
              <router-link to="/news"><dt>新闻动态</dt></router-link>
              <dd><router-link to="/news">新闻中心</router-link></dd>
            </div> -->
            <div class="footer-col">
              <router-link to="/contact"><dt>Contact Us</dt></router-link>
              <dd><router-link to="/contact">Contact Information</router-link></dd>
              <dd><router-link to="/contact">Online Inquiry</router-link></dd>
              <dd><router-link to="/contact">Global Offices</router-link></dd>
              <dd><router-link to="/contact">Partnership Opportunities</router-link></dd>
            </div>
            <div class="footer-col footer-phone">
              <img src="/imgs/home/images/footer-dianhua_03.png" alt="">
              <span>400 0000 1010</span>
            </div>
          </dl>
          <hr style="width: 100%; margin: 40px auto;">

      </div>

    </div>
  </footer>
      
  </div>
</template>

<script>
export default {
  components: {
      
  },
  data () {
      return {
          
      }
  },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
      
  },
}
</script>

<style scoped>
.footer {
min-height: 420px;
background-image: url(/public/imgs/home/images/footer-bg_02.png);
background-size: cover;
background-position: center;

font-size: 1.3rem;
color: #000000;
font-family: "HarmonyOS_Sans_SC_Light";

position: relative;
}

/* 底部整体布局 */
.footer-inner {
max-width: 1600px;
width: 100%;
margin: 0 auto;
padding: 80px 20px 40px;
}

/* 顶部区域 */
.footer-top {
width: 95%;
display: flex;
justify-content: space-between;
align-items: center;
margin-bottom: 40px;
}
.footer-top-title {
font-size: 3rem;
margin-bottom: 20px;
/* font-weight:550; */
color: #ff8a00;
letter-spacing: 0.01em;
}

/* 底部四列 */
.footer-bottom {
display: flex;
justify-content: space-between;
flex-wrap: wrap;
}
.footer-list {
width: 100%;
display: flex;
align-items: flex-start;
gap: 2vw;
margin: 0;
}
.footer-col {
/* flex: 1; */
min-width: 135px;
margin-bottom: 20px;
}
.footer-col dt {
font-weight: bold;
margin-bottom: 16px;
color: #000;
}
.footer-col dd {
margin: 0 0 8px 0;
line-height: 1.6;
}
.footer-col dd a {
  font-size: 1.1rem;
color: #454545;
text-decoration: none;
}
.footer-phone {
display: flex;
align-items: center;
margin-left: auto;
}
.footer-phone img {
margin-right: 10px;
}
.footer-phone span {
font-size: 1.8rem;
font-weight: 600;
/* color:#e60013; */
}
.footer-right {
  width: 100%;
display: flex;
justify-content: flex-end;
align-items: center;
}
.footer-right img {
margin: 0 10px;
}

/* 移动端隐藏 footer */
@media (max-width: 768px) {
.footer {
  display: none;
}
}

</style>